import React from 'react';
import { Badge } from 'react-bootstrap';
import Loading from '~/Components/Loading';
import Tabela from '~/Components/TabelaDinamica/Tabela';
import moment from 'moment';

const fmtDate = (d) => d ? moment(d).format('DD/MM/YYYY') : '-';
const fmt = (v) => v != null ? v : '-';

const renderOrigem = (origem) => (
  <Badge variant={origem === 0 ? 'secondary' : 'info'}>
    {origem === 0 ? 'CNAB' : 'Webservice'}
  </Badge>
);

const colunas = [
  { title: 'Data', key: 'data_ocorrencia', ordenacao: true, render: (v) => fmtDate(v) },
  { title: 'Origem', key: 'origem', render: (v) => renderOrigem(v) },
  { title: 'Código', key: 'codigo_ocorrencia' },
  { title: 'Descrição', key: 'descricao_ocorrencia', render: (v, item) => v || `Ocorrência ${item.codigo_ocorrencia}` },
  { title: 'Cliente', key: 'codigo_cliente', render: (v) => fmt(v) },
  { title: 'Motivo', key: 'codigo_motivo', render: (v) => fmt(v) },
];

const TabRemessa = ({ remessa, carregando }) => {
  if (carregando) return <Loading />;

  const totalLiquidacoes = remessa && remessa.length > 0
    ? (remessa[0].total_liquidacoes != null
      ? remessa[0].total_liquidacoes
      : remessa.filter((r) => r.codigo_ocorrencia === 6).length)
    : 0;

  if (!remessa || remessa.length === 0) {
    return <div className="text-muted p-3">Nenhum registro de remessa encontrado.</div>;
  }

  const dados = remessa.map((r, idx) => ({
    ...r,
    _key: `${r.origem}-${r.codigo_ocorrencia}-${r.sequencia != null ? r.sequencia : r.data_ocorrencia || idx}`,
  }));

  return (
    <div>
      <div className="px-3 py-2 border-bottom">
        <strong>Liquidações: {totalLiquidacoes}</strong>
      </div>
      <Tabela
        colunas={colunas}
        dados={dados}
        striped
        hover
      />
    </div>
  );
};

export default TabRemessa;
